<template>
  <li
    v-ar-feature-mask="{
      mode: 'transparent',
      show: !activationStateEnabled && !isFeatureEnabled,
      title: featureLockerTitle,
      message: featureLockerMessage,
    }"
    class="relative navbar-item"
  >
    <button
      v-tooltip.right="{
        value: item.tooltip ?? (isCollapsed ? item.name : null),
        hideDelay: 100,
        showDelay: 500,
      }"
      :aria-label="`Navigate to ${item.name}`"
      :aria-current="isActive ? 'page' : undefined"
      class="w-full flex items-center py-4 px-5 text-secondary group relative space-x-2 md:space-x-0 outline-transparent outline outline-1 ring-0 focus:outline-brand focus-visible:outline-brand rounded-r-md hover:focus:outline-transparent hover:bg-surface cursor-pointer"
      :class="{ 'text-brand': isActive }"
      :data-test-id="`sidebar-${item.key}-link`"
      @click="$emit('click', item)"
    >
      <!-- Active indicator -->
      <div
        class="absolute left-0 top-1/2 transform transition-75 -translate-y-1/2 w-1 h-10 rounded-r"
        :class="isActive ? 'bg-brand' : '' "
      />

      <!-- Icon -->
      <AM3Icon
        class="navbar-icon size-3  sm:size-6 "
        :type="item.iconType || 'document'"
        size="lg"
      />

      <!-- Label (only shown when expanded or on mobile) -->
      <span
        class="font-medium truncate block lg:hidden"
        :class="{ hidden: isCollapsed }"
      >
        {{ item.name }}
      </span>
    </button>
  </li>
</template>

<script setup lang="ts">
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'
import { generateFeatureLockerMessage, generateFeatureLockerTitle } from '@/utils/feature/index.js'

interface MenuItem {
  name: string
  key: string
  path: string
  iconType?: string
  featureKeys?: string[]
  tooltip?: string
}

interface Props {
  item: MenuItem
  isCollapsed: boolean
  isActive: boolean
  activationStateEnabled: boolean
  isFeatureEnabled: boolean
  isMobile: boolean
}

const props = defineProps<Props>()

defineEmits<{
  click: [item: MenuItem]
}>()

const featureLockerTitle = generateFeatureLockerTitle(props.item.name)
const featureLockerMessage = generateFeatureLockerMessage(props.item.name)
</script>

<style scoped>
:deep(.navbar-item:hover .navbar-icon svg) {
  color: var(--font-colour-brand);
}
</style>
